import { Badge, Icon } from '@/components/ui';

/**
 * "Verified", for a certificate an admin has checked. Shown to companies and
 * on the public portfolio, where the file itself never is. An unchecked
 * certificate shows nothing -- it is still the student's own claim.
 */
export function VerifiedBadge({ className }) {
  return (
    <Badge tone="success" className={className} title="An admin has checked this certificate">
      <Icon name="shieldCheck" size={12} />
      Verified
    </Badge>
  );
}
